import { render, staticRenderFns } from "./SignupListItem.vue?vue&type=template&id=56936da5&"
import script from "./SignupListItem.vue?vue&type=script&lang=ts&"
export * from "./SignupListItem.vue?vue&type=script&lang=ts&"
import style0 from "./SignupListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports